export const SOCKET_MESSAGE_PROVIDER = "da_viewer";
export const PROVIDER_RAYTEAMS = "rayteams";

export const STATUS = {
  INIT: "INIT", // 확인되지 않은 상태
  NEW: "NEW", // 최초 상태 
  TERMS: "TERMS", // 약관 동의 상태
  PROGRESSING: "PROGRESSING", // 아바타 업로드 상태
  SYNCED: "SYNCED", // 아바타 업로드 완료 상태
  CONFIRMED: "CONFIRMED", // 유저가 확인한 상태
  WRONG: "WRONG", // 아바타가 확인되지 않은 상태
  DELETE: "DELETE", // 아바타가 삭제된 상태 (삭제 후 일시적으로 유지됨)
};

export const SOCKET_EVENT_TYPE = {
  AVATAR_TERMS: "avatar_terms", // 송신용, 비밀번호 및 약관 동의 완료 상태
  PROGRESSING: "progressing", // 아바타 업로드 상태
  VIEW_READY: "view_ready", // 아바타 업로드 완료 상태
  CONFIRMED: "confirmed", // 유저가 아바타를 확인한 상태
  EXPIRED: "expired", // 외부 어플에서 만료됨
  DELETE: "DELETE", // 유저가 아바타를 삭제함
};